var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconrelatorios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.68,
    height: 38.331,
    viewBox: "0 0 40.68 38.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_relatorios",
    "data-name": "icon relatorios",
    transform: "translate(-17.142 -18.672)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_22391",
    "data-name": "Ret\\xE2ngulo 22391",
    width: 39.603,
    height: 1.419,
    transform: "translate(18.069 55.433)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30454",
    "data-name": "Caminho 30454",
    d: "M27.775,68.627H19.4V61.884A2.515,2.515,0,0,1,21.884,59.4H25.22A2.515,2.515,0,0,1,27.7,61.884v6.743Zm-6.955-1.419h5.465V61.884a1.092,1.092,0,0,0-1.065-1.065H21.884a1.092,1.092,0,0,0-1.065,1.065v5.323Z",
    transform: "translate(2.785 -11.774)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30456",
    "data-name": "Caminho 30456",
    d: "M67.5,62.27H59.2V39.984A2.515,2.515,0,0,1,61.684,37.5H65.02A2.515,2.515,0,0,1,67.5,39.984ZM60.619,60.85h5.465V39.984a1.092,1.092,0,0,0-1.065-1.065H61.684a1.092,1.092,0,0,0-1.065,1.065Z",
    transform: "translate(-12.529 -5.417)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30458",
    "data-name": "Caminho 30458",
    d: "M47.6,66.217H39.3V53.584A2.515,2.515,0,0,1,41.784,51.1H45.12A2.515,2.515,0,0,1,47.6,53.584ZM40.719,64.8h5.465V53.584a1.092,1.092,0,0,0-1.065-1.065H41.784a1.092,1.092,0,0,0-1.065,1.065Z",
    transform: "translate(-4.872 -9.365)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_2",
    "data-name": "Linha 2",
    x1: 37.19,
    y2: 19.518,
    transform: "translate(18.068 20.585)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30459",
    "data-name": "Caminho 30459",
    d: "M18.6,41.225a.745.745,0,0,1-.639-.355.718.718,0,0,1,.284-.994l37.19-19.518a.731.731,0,1,1,.71,1.278L18.953,41.155C18.811,41.155,18.74,41.225,18.6,41.225Z",
    transform: "translate(-0.529 -0.413)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30461",
    "data-name": "Caminho 30461",
    d: "M68.763,24.631H68.55a.771.771,0,0,1-.5-.852l.852-2.7-2.7-.852a.719.719,0,1,1,.5-1.349l4.046,1.278-1.278,3.975A.772.772,0,0,1,68.763,24.631Z",
    transform: "translate(-14.427 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconrelatorios);
export default __webpack_public_path__ + "static/media/icon relatorios.6a0f79e2bbd9c786029cd6f883cf33f0.svg";
export { ForwardRef as ReactComponent };